export const environment = {
  production: true,
  apiUrl: 'https://cdri.servizi.mquadro.net/api/v1',
};
//apiUrl: 'https://cdri.servizi.mquadro.net/api/v1'{{ apiUrl }}
//apiUrl: 'https://cdri.servizi.mquadro.net/api/v1',
//apiUrl: 'https://cdri.servizi.mquadro.net/api/v1',
//apiUrl: 'https://cdri.servizi.mquadro.net/api/v1',
//apiUrl: 'https://cdri.servizi.mquadro.net/api/v1',